import {AttributeDetailInfo} from 'src/openapi/models/AttributeDetailInfo';
import {RootState} from 'src/store/store';

export const getAttributeInfo = (state: RootState): Record<string, Array<AttributeDetailInfo>> =>
    state.attributeInfo.data;
